---
title: Legal
---

# Legal

Documents and disclosures that govern your use of TOBY.

The Terms and the privacy policy exist in two languages; the German version
is the binding one. The other two documents exist once, in English.

- [Terms of Service](/legal/terms) · [AGB (Deutsch, verbindliche Fassung)](/de/legal/terms)
- [Privacy Policy](/legal/privacy) · [Datenschutzerklärung (Deutsch, verbindliche Fassung)](/de/legal/privacy)
- [Imprint](/legal/imprint)
- [Data Processors](/legal/data-processors)
- [Deleting your account](/legal/delete-account)
